import React, { useState } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import {
  AddFeatureRequest,
  AddFeatureRequestFeatureNameEnum,
} from "../../../services/models";
import apiClient from "../../../utils/api";

const AddUserFeature: React.FC = () => {
  const [userId, setUserId] = useState("");
  const [featureName, setFeatureName] =
    useState<AddFeatureRequestFeatureNameEnum>();
  const [validUntil, setValidUntil] = useState<Date | null>(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const addUserFeature = async () => {
    if (!featureName) {
      console.error("Feature name is required");
      return;
    }
    const request: AddFeatureRequest = {
      featureName,
      targetId: userId,
      validUntil: validUntil ?? undefined,
    };
    try {
      await apiClient.featureFlagsControllerAddUserFeature({
        addFeatureRequest: request,
      });
    } catch (error: any) {
      setErrorMessage(
        error.message || "An error occurred while adding the feature."
      );
      setErrorDialogOpen(true);
    }
  };

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false);
    setErrorMessage("");
  };

  return (
    <Grid item xs={12} md={6}>
      <Typography variant="h6">Add Feature Flag to User</Typography>
      <TextField
        label="User ID"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        fullWidth
      />
      <TextField
        select
        label="Feature Name"
        value={featureName}
        onChange={(e) =>
          setFeatureName(e.target.value as AddFeatureRequestFeatureNameEnum)
        }
        fullWidth
      >
        {Object.values(AddFeatureRequestFeatureNameEnum).map((name) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Valid Until"
        InputLabelProps={{ shrink: true }}
        type="datetime-local"
        value={validUntil ? validUntil.toISOString().slice(0, -1) : ""}
        onChange={(e) =>
          setValidUntil(e.target.value ? new Date(e.target.value) : null)
        }
        fullWidth
      />
      <Button variant="contained" color="primary" onClick={addUserFeature}>
        Add Feature to User
      </Button>
      <Dialog open={errorDialogOpen} onClose={handleErrorDialogClose}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText>{errorMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrorDialogClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default AddUserFeature;
